import {
   getDocplannerAvailabilityLabel,
   getPatientPortalAvailabilityLabel,
   getWaitlistLabel,
   SourceLabelType,
} from './availabilityLabel';

type AppointmentSourceVisitor<T> = {
   visitEgabinet(): T;
   visitDocplanner(): T;
   visitPatientPortal(): T;
};

export const createAppointmentSourceVisitor = <T>(sourceLabel: string) => (visitor: AppointmentSourceVisitor<T>) => {
   if (sourceLabel === getDocplannerAvailabilityLabel()) {
      return visitor.visitDocplanner();
   }
   if (sourceLabel === getPatientPortalAvailabilityLabel()) {
      return visitor.visitPatientPortal();
   }
   return visitor.visitEgabinet();
};

export const isAppointmentSourceLabelApplicable = (
   sourceLabel: string
): sourceLabel is Exclude<SourceLabelType, 'waitlist'> => {
   return sourceLabel !== getWaitlistLabel();
};
